var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24SelectedPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 2.00488C11.341 2.00488 10.6815 2.25431 10.1829 2.75293L3.93581 9H2.24049C1.86549 9 1.51415 9.16605 1.27565 9.45605C1.03715 9.74555 0.94143 10.1227 1.01393 10.4902L2.75319 19.374C3.05069 20.8955 4.39164 22 5.94264 22H18.0491C19.6001 22 20.941 20.8955 21.2385 19.374L22.9768 10.4902L22.9778 10.4893C23.0488 10.1213 22.9531 9.74408 22.7151 9.45508C22.4766 9.16608 22.1248 9 21.7503 9H20.0647L13.8167 2.75293C13.318 2.25431 12.6595 2.00488 12.0003 2.00488ZM12.0003 3.49609C12.2725 3.49609 12.5442 3.6016 12.7561 3.81348L17.9436 9H6.0569L11.2434 3.81348C11.4553 3.6016 11.728 3.49609 12.0003 3.49609ZM15.2493 12.5C15.4412 12.5 15.6331 12.5732 15.7796 12.7197C16.0731 13.0122 16.073 13.4873 15.7805 13.7803L11.2805 18.2803C11.134 18.4268 10.9423 18.5 10.7503 18.5C10.5583 18.5 10.3665 18.4268 10.22 18.2803L8.21999 16.2803C7.92698 15.9878 7.92698 15.5122 8.21999 15.2197C8.51299 14.9267 8.98753 14.9267 9.28053 15.2197L10.7493 16.6895L14.719 12.7197C14.8655 12.5732 15.0574 12.5 15.2493 12.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24SelectedPurchase);
export default __webpack_public_path__ + "static/media/icn_24x24_selected_purchase.934511336ebfc2df6d6887435c5e0882.svg";
export { ForwardRef as ReactComponent };